import { apiClient } from "@/services/apiClient";

/**
 * Telegram linked-chat types. Mirror of backend `domains/telegram` shapes.
 * Camel-case conversion happens at the service boundary.
 */
export type TelegramPurpose = "idea_capture" | "admin";

export type TelegramChatStatus = "pending" | "linked";

export interface TelegramChat {
  id: string;
  chatId: number;
  agencyId: string | null;
  purpose: TelegramPurpose | null;
  title: string | null;
  status: TelegramChatStatus;
  linkedAt: string | null;
}

export interface TelegramChatsResponse {
  linked: TelegramChat[];
  pending: TelegramChat[];
}

export const telegramService = {
  async listChats(): Promise<TelegramChatsResponse> {
    return apiClient.get<TelegramChatsResponse>("/api/telegram/chats");
  },

  async linkChat(params: {
    chatId: number;
    purpose: TelegramPurpose;
    manual?: boolean;
  }): Promise<TelegramChat> {
    return apiClient.post<TelegramChat>("/api/telegram/chats/link", {
      chatId: params.chatId,
      purpose: params.purpose,
      manual: params.manual ?? false,
    });
  },

  async unlinkChat(chatId: number): Promise<void> {
    await apiClient.post("/api/telegram/chats/unlink", { chatId });
  },
};
